import restapi from 'utils/restapi';
import { addLang } from "utils/addLang";

import { baseErrorsHandlerDecorator } from 'redux/utils';

import {
  FETCH_MUSIC_LINKS_LIST,
  FETCH_MUSIC_LINKS_LIST_ERROR,
  CLEAR_MUSIC_LINKS_LIST,
  ADD_MUSIC_LINK_SUCCESS,
  ADD_MUSIC_LINK_ERROR,
  CLEAR_MUSIC_LINK_STATUS,
  PATCH_MUSIC_LINK_SUCCESS,
  PATCH_MUSIC_LINK_ERROR,
  CLEAR_MUSIC_LINK_PATCH_STATUS,
  DELETE_MUSIC_LINK_SUCCESS,
  DELETE_MUSIC_LINK_ERROR,
  CLEAR_MUSIC_LINK_DELETE_STATUS,
  APPLY_MUSIC_LINK_DRAG,
  APPLY_MUSIC_LINK_DRAG_ERROR,
  CLEAR_MUSIC_LINK_DRAG,
  FETCH_MUSIC_LINK_DETAILS,
  FETCH_MUSIC_LINK_DETAILS_ERROR,
  CLEAR_MUSIC_LINK_DETAILS,
  PATCH_MUSIC_MEDIA_SAMPLE_SUCCESS,
  PATCH_MUSIC_MEDIA_SAMPLE_ERROR,
  CLEAR_MUSIC_MEDIA_SAMPLE_PATCH_STATUS,
  UPDATE_MUSIC_LINK_SOURCE_SUCCESS,
  UPDATE_MUSIC_LINK_SOURCE_ERROR,
  CLEAR_MUSIC_LINK_UPDATE_SOURCE_STATUS,
  ADD_MUSIC_SERVICE_LINK_SUCCESS,
  ADD_MUSIC_SERVICE_LINK_ERROR,
  CLEAR_ADD_MUSIC_SERVICE_LINK,
  PATCH_MUSIC_SERVICE_LINK_SUCCESS,
  PATCH_MUSIC_SERVICE_LINK_ERROR,
  CLEAR_PATCH_MUSIC_SERVICE_LINK,
  DELETE_MUSIC_SERVICE_LINK_SUCCESS,
  DELETE_MUSIC_SERVICE_LINK_ERROR,
  CLEAR_DELETE_MUSIC_SERVICE_LINK,
} from 'redux/music-links/types';

export const fetchMusicLinksList = () => baseErrorsHandlerDecorator(
  FETCH_MUSIC_LINKS_LIST,
  FETCH_MUSIC_LINKS_LIST_ERROR,
  () => restapi.get(addLang('links/music_links/')),
  false,
  false,
);

export const clearMusicLinksList = () => dispatch => {
  dispatch({
    type: CLEAR_MUSIC_LINKS_LIST,
  });
};

export const addMusicLink = linkSource => baseErrorsHandlerDecorator(
  ADD_MUSIC_LINK_SUCCESS,
  ADD_MUSIC_LINK_ERROR,
  () => restapi.post(addLang('links/music_links/'), { link_source: linkSource }),
  false,
  true,
);

export const clearMusicLinkStatus = () => dispatch => {
  dispatch({
    type: CLEAR_MUSIC_LINK_STATUS,
  });
};

export const patchMusicLink = (linkId, formData) => baseErrorsHandlerDecorator(
  PATCH_MUSIC_LINK_SUCCESS,
  PATCH_MUSIC_LINK_ERROR,
  () => restapi.patch(addLang(`links/music_links/${linkId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearMusicLinkPatchStatus = () => dispatch => {
  dispatch({
    type: CLEAR_MUSIC_LINK_PATCH_STATUS,
  });
};

export const patchMediaSample = (linkId, formData) => baseErrorsHandlerDecorator(
  PATCH_MUSIC_MEDIA_SAMPLE_SUCCESS,
  PATCH_MUSIC_MEDIA_SAMPLE_ERROR,
  () => restapi.patch(addLang(
    `links/music_links/${linkId}/update-sample-playback/`
  ), formData),
  false,
  true /* actionSucces */,
);

export const clearMediaSamplePatchStatus = () => dispatch => {
  dispatch({
    type: CLEAR_MUSIC_MEDIA_SAMPLE_PATCH_STATUS,
  });
};

export const updateMusicLinkSource = (linkId, formData) => baseErrorsHandlerDecorator(
  UPDATE_MUSIC_LINK_SOURCE_SUCCESS,
  UPDATE_MUSIC_LINK_SOURCE_ERROR,
  () => restapi.post(addLang(`links/music_links/${linkId}/update-source/`), formData),
  false,
  true /* actionSucces */,
);

export const clearMusicLinkSourceUpdateStatus = () => dispatch => {
  dispatch({
    type: CLEAR_MUSIC_LINK_UPDATE_SOURCE_STATUS,
  });
};

export const deleteMusicLink = linkId => baseErrorsHandlerDecorator(
  DELETE_MUSIC_LINK_SUCCESS,
  DELETE_MUSIC_LINK_ERROR,
  () => restapi.delete(addLang(`links/music_links/${linkId}/`)),
  false,
  true,
);

export const clearMusicLinkDeleteStatus = () => dispatch => {
  dispatch({
    type: CLEAR_MUSIC_LINK_DELETE_STATUS,
  });
};

export const applyMusicLinksDrag = formData => baseErrorsHandlerDecorator(
  APPLY_MUSIC_LINK_DRAG,
  APPLY_MUSIC_LINK_DRAG_ERROR,
  () => restapi.post(addLang('links/music_links/ordering/'), formData),
  false,
  true /* actionSucces */,
);

export const clearMusicLinksDrag = () => dispatch => {
  dispatch({
    type: CLEAR_MUSIC_LINK_DRAG,
  });
};

export const fetchMusicLinkDetails = linkId => baseErrorsHandlerDecorator(
  FETCH_MUSIC_LINK_DETAILS,
  FETCH_MUSIC_LINK_DETAILS_ERROR,
  () => restapi.get(addLang(`links/music_links/${linkId}/`)),
  false,
  false /* actionSucces */,
);

export const clearMusicLinkDetails = () => dispatch => {
  dispatch({
    type: CLEAR_MUSIC_LINK_DETAILS,
  });
};

export const addMusicServiceLink = formData => baseErrorsHandlerDecorator(
  ADD_MUSIC_SERVICE_LINK_SUCCESS,
  ADD_MUSIC_SERVICE_LINK_ERROR,
  () => restapi.post(addLang('links/music_links/music-service-link/'), formData),
  false,
  true,
);

export const clearAddMusicServiceLink = () => dispatch => {
  dispatch({
    type: CLEAR_ADD_MUSIC_SERVICE_LINK,
  });
};

export const patchMusicServiceLink = (linkId, formData) => baseErrorsHandlerDecorator(
  PATCH_MUSIC_SERVICE_LINK_SUCCESS,
  PATCH_MUSIC_SERVICE_LINK_ERROR,
  () => restapi.patch(addLang(`links/music_links/music-service-link/${linkId}/`), formData),
  false,
  true /* actionSucces */,
);

export const clearPatchMusicServiceLink = () => dispatch => {
  dispatch({
    type: CLEAR_PATCH_MUSIC_SERVICE_LINK,
  });
};

export const deleteMusicServiceLink = linkId => baseErrorsHandlerDecorator(
  DELETE_MUSIC_SERVICE_LINK_SUCCESS,
  DELETE_MUSIC_SERVICE_LINK_ERROR,
  () => restapi.delete(addLang(`links/music_links/music-service-link/${linkId}/`)),
  false,
  true,
);

export const clearDeleteMusicServiceLink = () => dispatch => {
  dispatch({
    type: CLEAR_DELETE_MUSIC_SERVICE_LINK,
  });
};
